import {Component, OnDestroy, OnInit} from '@angular/core';
import {BoosterService} from "../services/booster.service";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import * as fromStore from '../../../../store';
import {Subject} from "rxjs";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {DbModalService} from "../../../../modules/modal/modal";
import {combineLatest} from "rxjs";
import {UserSubscription, UserSubscriptionCategory} from "../../../../user/user-subscription";
import {ActivatedRoute, Router} from "@angular/router";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {Website} from "../../website";
import {Utils} from "../../../../shared/utils/utils";


@Component({
    selector: 'db-white-label',
    templateUrl: './white-label.component.html',
    styleUrls: ['./white-label.component.scss'],
    standalone: false
})
export class BoosterWhiteLabelComponent implements OnInit, OnDestroy {

  public website: Website;
  public currentSubscription: UserSubscription;
  public whiteLabelItems: string[] = ['Plugin name', 'Active plugin list', 'Plugin settings in WP admin'];
  public loadingApply: boolean;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public notConnected: boolean;
  public showPercentOffer: boolean;

  constructor(
    private _dialogService: DialogService,
    private _boosterService: BoosterService,
    private _store: Store<DbStoreState>,
    private _dbModalService: DbModalService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _modalService: DbModalService,
  ) {}

  ngOnInit() {
    this.website = this._route.snapshot.parent.parent.data['website'];
    if (!TypeUtils.isNull(this._route.snapshot.data['boosterTroubleshootData'])) {
      const disconnected = this._route.snapshot.data['boosterTroubleshootData'] === 'alive_but_not_connected';
      const restNoRoute = this._route.snapshot.data['boosterTroubleshootData'] === 'error';
      this.notConnected = disconnected || restNoRoute;
    }
    this._getUserAndSubscriptionData();
    this._showPercentOffer();
  }

  private _showPercentOffer() {
    const percentOfferEndDate = new Date("2024-01-30 18:00:00").getTime();
    const datesDiff = Utils.getTimeDiffFromToday(percentOfferEndDate);
    this.showPercentOffer = datesDiff && this.currentSubscription && this.currentSubscription.trialBoosterClient;
  }

  private _getUserAndSubscriptionData(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription)
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([user, userSubscription]) => {
        this.currentSubscription = userSubscription;
      });
  }

  public upgrade(): void {
    this._router.navigate(['/upgrade-plan']);
  }

  ngOnDestroy() {
  }

}
